import React, { useEffect, useState } from "react";
import { RotateCw } from "lucide-react";
import { fetchReports } from "../services/reports";

const ReportsAdmins = () => {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [reportType, setReportType] = useState("general");
    const [sortBy, setSortBy] = useState(null);
    const [sortDir, setSortDir] = useState("asc");

    useEffect(() => {
        // Якщо обрано 'general' — завантажуємо звіт по локаціях
        if (reportType === 'general') {
            loadData();
        } else {
            // Новий звіт — очищуємо
            setReports([]);
        }

        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [reportType]);

    const loadData = async () => {
        try {
            setLoading(true);
            const data = await fetchReports();
            setReports(data);
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p>Завантаження...</p>;
    if (error) return <p style={{ color: "red" }}>Помилка: {error}</p>;

    const displayedReports = (() => {
        if (!reports) return [];
        const list = reports.slice();
        if (sortBy === 'location_name') {
            list.sort((a, b) => {
                const va = (a.location_name || '').toString().toLowerCase();
                const vb = (b.location_name || '').toString().toLowerCase();
                if (va === vb) return 0;
                return sortDir === 'asc' ? (va > vb ? 1 : -1) : (va < vb ? 1 : -1);
            });
        }
        return list;
    })();

    return (
        <div>
            <div className="config-header">
                <div className="header-buttons">
                    <button className="add-btn refresh toolbar-icon-btn" onClick={loadData} disabled={loading} title="Оновити" aria-label="Оновити">
                        <RotateCw size={16} className={loading ? "spin" : ""} />
                    </button>
                </div>
            </div>
            <div className="filters-bar" style={{ marginBottom: 10 }}>
                <select
                    value={reportType}
                    onChange={(e) => setReportType(e.target.value)}
                    aria-label="Тип звіту"
                >
                    <option value="general">Загальні ціни</option>
                    <option value="new">Новий звіт</option>
                </select>
            </div>

            {isMobile ? (
                <div className="config-grid">
                    {displayedReports.map((r) => (
                        <div key={r.location_id} className="config-card">
                            <div><strong>Локація:</strong> {r.location_name}</div>
                            <div><strong>Сума:</strong> {r.total_price} ₴</div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th className="sortable" onClick={() => { setSortBy('location_name'); setSortDir(sortBy === 'location_name' && sortDir === 'asc' ? 'desc' : 'asc'); }}>Назва локації</th>
                                <th>Витрати</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayedReports.map((r) => (
                                <tr key={r.location_id}>
                                    <td>{r.location_id}</td>
                                    <td>{r.location_name}</td>
                                    <td>{r.total_price} ₴</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default ReportsAdmins;
